import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { API } from "../../context/AuthContext";

const inp = "w-full bg-gray-900 border border-white/10 rounded-lg px-2 py-1.5 text-[11px] text-gray-200 focus:outline-none focus:border-[#f59e0b]/50";

export default function NewTemplateForm({ onCreated }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ template_id: "", display_name: "", fields: "" });

  const create = async () => {
    try {
      const r = await axios.post(`${API}/admin/templates`, { ...form, fields: form.fields.split(/[,\n]/).map((s) => s.trim()).filter(Boolean) });
      toast.success(`Template "${r.data.display_name}" created.`);
      setForm({ template_id: "", display_name: "", fields: "" });
      setOpen(false);
      onCreated(r.data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't create the template");
    }
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} data-testid="new-template-btn" className="w-full flex items-center gap-1 px-3 py-2 text-[11px] font-mono text-[#f59e0b] hover:bg-white/5 rounded-lg">
        <Plus className="w-3 h-3" /> New template
      </button>
    );
  }
  return (
    <div className="p-2 space-y-2 border-t border-white/5" data-testid="new-template-form">
      <input value={form.template_id} onChange={(e) => setForm({ ...form, template_id: e.target.value })} placeholder="template_id (e.g. w2_form)" className={`${inp} font-mono`} data-testid="new-template-id" />
      <input value={form.display_name} onChange={(e) => setForm({ ...form, display_name: e.target.value })} placeholder="Display name" className={inp} data-testid="new-template-name" />
      <textarea value={form.fields} onChange={(e) => setForm({ ...form, fields: e.target.value })} placeholder="field keys, comma separated" rows={3} className={`${inp} font-mono`} data-testid="new-template-fields" />
      <div className="flex gap-2">
        <button onClick={create} data-testid="new-template-create" className="flex-1 text-[11px] font-bold py-1.5 rounded-lg bg-[#f59e0b] text-gray-950">Create</button>
        <button onClick={() => setOpen(false)} className="flex-1 text-[11px] py-1.5 rounded-lg border border-white/10 text-gray-400">Cancel</button>
      </div>
    </div>
  );
}
